import { getAdvertisingApi } from '@/api/common'
import type { IAdvertisingItem } from '@/api/common/types'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useAdvertisingStore = defineStore('advertising', () => {
  const advertising = ref<IAdvertisingItem[]>([])
  const curAdvertising = computed(() => {
    return advertising.value[0]
  })

  const getAdvertising = async () => {
    try {
      const res = await getAdvertisingApi()
      advertising.value = res
      if (res?.length) {
      }
    } catch (error: any) {
      throw new Error(error)
    }
  }

  return {
    getAdvertising,
    advertising,
    curAdvertising,
  }
})
